import { v4 as uuidv4 } from 'uuid';

const previewList = [
    {
        idSoft: uuidv4(),
        name: "/assets/images/4_m.png",
        text: '4 personnes semi-pied',
        value: "/assets/images/4_m.png",
    },
    {
        idSoft: uuidv4(),
        name: "/assets/images/2_m.png",
        text: '2 personnes semi-pied',
        value: "/assets/images/2_m.png",
    },
    {
        idSoft: uuidv4(),
        name: "/assets/images/4_f.png",
        text: '4 personnes plain pied',
        value: "/assets/images/4_f.png",
    },
    {
        idSoft: uuidv4(),
        name: "/assets/images/2_f.png",
        text: '2 personnes plain pied',
        value: "/assets/images/2_f.png",
    },
];

export default previewList;